import Form from 'src/utils/Form.js'

class Kyc extends Form {
    constructor(data) {
        super(data);
    }

    fetch(then) {
        return super.get(`kyc`).then(data => {
            this.originalData = data
            for (let field in this.originalData) {
                this[field] = data[field]
            }
            this.documents = {}
            then(data)
        })
    }

    send(then) {
        return super.post('/kyc/send').then(then)
    }

    register(then) {
        const fd = this.formData(['documents'])

        return super.post('/kyc/register', fd).then(({message}) => {
            then(message)
        })
    }

    onSuccess (data) {
        this.originalData.documents = {}
        for (const field in this.originalData) {
            if (field === 'documents') {
                this[field] = {}
            } else {
                this[field] = ''
            }
        }
        this.errors.clear()
    }

    registerDocuments(then) {
        const fd = this.formData(['documents'])

        return super.post(`kyc/documents`, fd).then(then)
    }
}

export default Kyc;
